import { PERIOD_DEPENDENT_ASSETS, DEFAULT_APPS_FILTERS } from '../configs/constants';
import { updateCurrentPath } from '../utils/url-sync';
import { fetchPageData } from './page-data-actions';
import { SET_FILTERS, SET_APPS_FILTERS } from './actionTypes';

export const syncFiltersToUrl = (state) => {
  const { filters, apps } = state;
  const { metric, order, offset } = apps.filters;
  const isDefaultSort =
    metric === DEFAULT_APPS_FILTERS.metric && order === DEFAULT_APPS_FILTERS.order;

  updateCurrentPath({
    ...filters,
    metric: isDefaultSort ? null : metric,
    order: isDefaultSort ? null : order,
    offset: offset || null,
  });
};

export const changePeriod = (periodFilters) => (dispatch, getState) => {
  dispatch({ type: SET_FILTERS, payload: periodFilters });
  dispatch({ type: SET_APPS_FILTERS, payload: { offset: 0 } });

  syncFiltersToUrl(getState());

  return dispatch(fetchPageData(PERIOD_DEPENDENT_ASSETS));
};
